export const TREATMENT_MODALITY_OPTIONS = [
  { value: "DIRECT", label: "Direct Therapy" },
  { value: "CAREGIVER_MEDIATED", label: "Caregiver Mediated" },
  { value: "CAREGIVER_TRAINING_ONLY", label: "Caregiver Training Only" },
];

export const TREATMENT_MODALITY_RATIONALE_OPTIONS_BY_MODALITY: Record<
  string,
  { value: string; label: string }[]
> = {
  CAREGIVER_MEDIATED: [
    {
      value: "APPROPRIATENESS_OF_RECOMMENDED_GOALS_CAREGIVER_PRIORITIES",
      label: "Appropriateness of the recommended goals based on caregiver priorities being targeted through caregiver mediated services",
    },
    {
      value: "LACK_OF_PREREQUISITE_SKILLS",
      label: "Lack of prerequisite skills",
    },
    {
      value: "NEED_FOR_FREQUENT_REDIRECTION_AND_PROMPTS",
      label: "Need for frequent redirection and prompts",
    },
    {
      value: "FREQUENTLY_LEAVING_AREA_DURING_INITIAL_ASSESSMENT",
      label: "Frequently leaving the area during the initial assessment",
    },
  ],
  DIRECT: [
    {
      value: "NEED_TO_WORK_ON_SKILLS_UNCOMFORTABLE_WITH_CAREGIVER",
      label: "Need to work on skills that may be uncomfortable to target with a caregiver present",
    },
    {
      value: "SUFFICIENT_PREREQUISITE_SKILLS_FOR_INDEPENDENT_SESSIONS",
      label: "Sufficient prerequisite skills to participate independently in sessions",
    },
    {
      value: "PRESENCE_OF_PREREQUISITE_SKILLS_FOR_BCBA_INTERACTION",
      label: "Presence of prerequisite skills for interacting directly with the BCBA and stimuli presented via the screen during initial assessment",
    },
    {
      value: "APPROPRIATENESS_OF_CLIENT_PRIORITIES_DIRECT_THERAPY_BCBA",
      label: "Appropriateness of client priorities being targeted via direct therapy with a BCBA",
    },
  ],
  CAREGIVER_TRAINING_ONLY: [
    {
      value: "SIGNIFICANT_NEEDS_CHALLENGING_SESSIONS_FAMILY_COMMITTED",
      label: "Significant needs that would make regular participation in sessions challenging. The family is committed to active involvement in sessions and practicing skills outside of caregiver training with the BCBA",
    },
    {
      value: "MEDICAL_NECESSITY_CAREGIVER_SKILL_DEVELOPMENT",
      label: "Medical necessity that the caregiver develops the skills to support the client's skill acquisition and behavior reduction",
    },
  ],
};

export const TREATMENT_MODALITY_RATIONALE_OPTIONS = Object.values(
  TREATMENT_MODALITY_RATIONALE_OPTIONS_BY_MODALITY
).flat();

export const getLabelFromOptions = (
  options: { value: string; label: string }[],
  value: string | null | undefined
): string => {
  if (!value) return "";
  return options.find((o) => o.value === value)?.label ?? value;
};
